import { render, staticRenderFns } from "./Recount__modelsRel.vue?vue&type=template&id=6b6ca952&scoped=true&"
import script from "./Recount__modelsRel.vue?vue&type=script&lang=js&"
export * from "./Recount__modelsRel.vue?vue&type=script&lang=js&"
import style0 from "./Recount__modelsRel.vue?vue&type=style&index=0&id=6b6ca952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ca952",
  null
  
)

export default component.exports